import actionTypes from 'SRC/modules/redux/actionTypes'

export const setServiceTypes = serviceTypes => ({
  type: actionTypes.SET_SERVICE_TYPES,
  payload: serviceTypes
})
